import { Component, inject } from '@angular/core';
import { AuthenticationService } from 'src/app/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['footer.component.scss'],
  standalone: false
})
export class FooterComponent {
  private readonly authenticationService = inject(AuthenticationService);

  readonly portalSupportLink = 'https://app.smartsheet.com/b/form/3511b90b2c4c4aa383763192c667aba6';
  readonly reportAnIssueLink = 'https://forms.office.com/Pages/ResponsePage.aspx?id=8giMvgesLESaRuvu61vU1yB75tQvYmxJmyOSqbUgz-ZURERHWEJUT0k1M0ZXWUJHQkNKSzRSWkxXMS4u';

  isExternal: boolean = false;

  ngOnInit(): void {
    this.isExternal = this.authenticationService.isExternalUser;
  }
}
